// extracted by mini-css-extract-plugin
export default {"table":"DataTable__table___Zfnmq","table_heading":"DataTable__table_heading___oKLPF","table_footer":"DataTable__table_footer___Lcii5"};